import { Box, Typography } from "@material-ui/core";

/**
 * Componente de selo de estrela giratória com texto customizável.
 * @param {object} props - As propriedades do componente.
 * @param {string} props.line1 - A primeira linha de texto (maior).
 * @param {string} props.line2 - A segunda linha de texto (menor).
 * @param {string} props.line3 - A terceira linha de texto (menor).
 */
const RotatingStarBadge = ({ line1, line2, line3 }) => {
  // O novo tamanho da estrela foi reduzido para 120px
  const size = 80;

  return (
    <Box
      sx={{
        position: "relative",
        width: size,
        height: size,
      }}
    >
      {/* O SVG da estrela que irá girar */}
      <Box
        className="rotating-star" // Aplica a animação do Animation.css
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%" // SVG agora ocupa 100% do container
          height="100%"
          viewBox="0 0 167 167" // O viewBox é mantido para escalar o desenho corretamente
          fill="none"
        >
          <path
            d="M83.5 0L102.302 13.3303L125.25 11.1869L134.868 32.1322L155.813 41.75L153.67 64.6981L167 83.5L153.67 102.302L155.813 125.25L134.868 134.868L125.25 155.813L102.302 153.67L83.5 167L64.6981 153.67L41.75 155.813L32.1322 134.868L11.1869 125.25L13.3303 102.302L0 83.5L13.3303 64.6981L11.1869 41.75L32.1322 32.1322L41.75 11.1869L64.6981 13.3303L83.5 0Z"
            fill="#F9E925"
          />
        </svg>
      </Box>

      {/* O texto estático, com fontes ajustadas */}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          color: "black",
          zIndex: 1,
          width: "100%",
        }}
      >
        <Typography
          sx={{
            fontWeight: "900",
            lineHeight: 1.1,
            fontSize: "1rem",
            textTransform: "uppercase",
          }}
        >
          {line1}
        </Typography>
        <Typography
          sx={{
            fontWeight: "bold",
            textTransform: "uppercase",
            fontSize: "0.6rem",
          }}
        >
          {line2}
        </Typography>
        <Typography
          sx={{
            fontWeight: "bold",
            textTransform: "uppercase",
            fontSize: "0.6rem",
          }}
        >
          {line3}
        </Typography>
      </Box>
    </Box>
  );
};

export default RotatingStarBadge;
